// extracted by mini-css-extract-plugin
export default {"title":"SharedStyles_title__DQRDZ"};